/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Button from '../../fields/Button';
import TextArea from '../../fields/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { HandleFormData } from '../../../../utilites';
import allActions from '../../../../Store/action';

const FarmRental = () => {

    const dispatch=useDispatch()
	const [{ taxPayerForm, taxPayerFormData, formInformation }] = useSelector((state) => [state.taxForms]);
	const uploadFormData = HandleFormData({ parentIndex: 0, myIndex: 24});
    
    // form States
	const [farmLocation, setFarmLocation] = useState();
	const [conservationEasement, setConservationEasement] = useState(null);

    const [errors, setErrors] = useState({}); // Track errors for form fields

	// SAVE VALUES TO STATES
    useEffect(() => {
    	if (taxPayerForm?.data?.FarmRental) {
    		if (Object.keys(taxPayerForm?.data?.FarmRental).length === 0) return;
			const {
                farmLocation,
                conservationEasement
			} = taxPayerForm?.data?.FarmRental;
            setFarmLocation(farmLocation)
            setConservationEasement(conservationEasement)
    	}
    }, [taxPayerForm?.data?.FarmRental]);

    const check_Validity = () => {
        setErrors({});
        const newErrors = {};
    
        // Add more validation rules as needed for other fields
        if (
            conservationEasement===null) {
            newErrors.AnswerOtherQuestions = 'Please Select Required Option';
        }
    
        setErrors(newErrors);
    
        let ConditionCheck = Object.keys(newErrors).length === 0 ? false : true;
        // Check if there are any errors
        return ConditionCheck;
    };

	const handleSubmit = (e) => {
		e.preventDefault();

        let errors = check_Validity();
        if (errors) return;

        let FormObj = {
            farmLocation,
            conservationEasement
		};
        let formData = taxPayerForm;
        taxPayerForm.data.FarmRental = FormObj;
        dispatch(allActions.taxForms.StoreFormData({ formData }));
        uploadFormData(formData);
    };
    const goBack = () => {
		// CHANGE FORM TO BACK
		let parentIndex = 0;
		let myIndex = 24;
		dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
	};

	return (
        <form className="w-100 mt-3" onSubmit={handleSubmit}>
            <div className="mt-3 row justify-content-between px-3 custom-left-form">
                <div className="col-md-12 mb-3">
                    <small className="ml-4 fw-bold">Location of the farm rental</small>
                    <TextArea
                        inputName="form-control"
                        defaultValue={farmLocation}
                        placeholder=""
                        name="location"
                        fn={setFarmLocation}
                        row="6"
                    />
                </div>
                <div
                className="w-100 mt-2"
            >
                <small className="col-md-8 form-check-label text-start" htmlFor={`checkbox`}>
				Does the farm rental currently have a conservation easement in place?
                {conservationEasement===null && (
                    <span className="text-danger small-text mx-1">*Required</span>
                )}
                </small>
                <div className="col-md-4">
                    <input
                        onChange={() => setConservationEasement(true)}
                        checked={conservationEasement === true}
                        className="form-check-input"
                        type="radio"
                        id={`checkbox-div4`}
                        name={`checkbox-div4`}
                    />
                    <label htmlFor={`checkbox-div4`} role="button" className="px-3 m-0 small">
                        Yes
                    </label>
                    <input
                        onChange={() => setConservationEasement(false)}
                        checked={conservationEasement === false}
                        className="form-check-input"
                        type="radio"
                        id={`checkbox-div5`}
                        name={`checkbox-div5`}
                    />
                    <label htmlFor={`checkbox-div5`} role="button" className="px-3 m-0 small">
                        No
                    </label>
                </div>
            </div>
            </div>
            {Object.keys(errors)
    ?.map((key) => {
        return errors[key];
    })
    ?.map((data, index) => {
        return (
            <>
                <small className="text-primary" key={index}>
                    {data}*
                </small>
                <br />
            </>
        );
    })}
            <div className="container-fluid content-row pb-4">
                <div className="d-flex align-items-center justify-content-center row">
                    <Button
                        mainClass="btn btn-info custon-button-text w-100 text-dark"
                        buttonText="Previous"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="button"
                        callback={()=>goBack()}
                    />
                    <Button
                        mainClass="btn btn-primary custon-button-text w-100"
                        buttonText="Next"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="submit"
                        disabled={!formInformation?.lead_id}
                    />
                </div>
            </div>
        </form>
	);
};

export default FarmRental;